export enum Brand {
    'LG' = 'LG', 'DA' = 'Daikin'
}

export enum HouseType {
    'open', 'closed', 'halfopen', 'apartment'
}

export enum PlacementOutside {
    'ground', 'flatRoof', 'facadeLow', 'facadeHigh', 'roof', 'noClue'
}

export enum WallType {
    'concrete', 'quickBuild', 'woodenSkeleton', 'crepi', 'noClue'
}

export enum CableTrayType {
    'standard', 'design', 'galvanized', 'aluminium', 'noClue'
}

export enum RoomType {
    'bedroom', 'livingroom', 'garage', 'cellar', 'attic', 'other'
}

export type ImageSelectEnums = RoomType | CableTrayType | WallType | PlacementOutside | HouseType;